import pageNow from '../utils/pageNow';

const isFunction = func => typeof func === 'function';
const isString = string => typeof string === 'string';

const routes = [];

const router = {
  /**
   * @param {string} route
   * @param {function} callback
   * @returns {router}
   */
  add(route, callback) {
    if (!isFunction(callback)) {
      throw new Error('callback parameter must be a function');
    }

    if (!isString(route)) {
      throw new Error('route parameter must be a string or an array');
    }

    routes.push({
      callback,
      path: route,
    });

    return this;
  },
  /**
   * @returns {router}
   */
  run() {
    routes.forEach((route) => {
      if (route.path === 'all' || pageNow.is(route.path)) {
        route.callback();
      }
    });

    return this;
  },
};

export default router;
